"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isBrowser_1 = __importDefault(require("./isBrowser"));
const setLocalStorage = (key, value) => {
    if (!isBrowser_1.default)
        return;
    if (key && value === null) {
        window.localStorage.removeItem(key);
        return;
    }
    if (!key || !value || typeof value !== "object") {
        console.warn("setLocalStorage requires a key and an object");
        return;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
};
exports.default = setLocalStorage;
